import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=64e5d044&"
import script from "./Business.vue?vue&type=script&lang=js&"
export * from "./Business.vue?vue&type=script&lang=js&"
import style0 from "./Business.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports